var option_default = {
  "option": "P2QUr",
  "user_choice": "cjm0l",
  "check": "tdgGT",
  "image": "sJW9W",
  "input": "tXd96",
  "title": "oHlMD",
  "centered": "niwJQ",
  "with_result": "DQb1-",
  "list": "StjZO",
  "with_image": "noWsC",
  "progress": "P-Joi",
  "progress_value": "yUhtZ",
  "label": "_8zpDh",
  "cta": "fHm7m",
  "adornment_icon": "H8u4s",
  "remove": "h7FfK",
  "removeButton": "C2gXs",
  "removeButtonIcon": "Y6Htw",
  "overlay": "Ej9G8",
  "shown": "H8S-A",
  "dark": "iGx0p",
  "spinner": "u41SC",
  "spin": "r1v31"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
